import apiClient from "./client";

export function login({ username, password }) {
    return apiClient.post('/api/token/', { username, password });
  }
  
  export function refreshToken(refresh) {
    return apiClient.post('/api/token/refresh/', { refresh });
  }

export function requestPasswordReset({ email }) {
    return apiClient.post('/api/password-reset/', { email });
  }

export function confirmPasswordReset({ uid, token, new_password, confirm_password }) {
    return apiClient.post('/api/password-reset/confirm/', {
      uid,
      token,
      new_password,
      confirm_password,
    });
  }
